import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../admin/api";

const SiteCtx = createContext(null);

const DEFAULTS = {
  site_name: "Mzough U Kasev Tiv",
  tagline: "National Body of Tiv Women Association Nigeria",
  logo_url: "",
  favicon_url: "",
  primary_color: "9 70% 62%",
  secondary_color: "350 45% 35%",
  accent_color: "5 80% 65%",
  contact_email: "",
  contact_phone: "",
  address: "",
  office_hours: "",
  facebook_url: "",
  instagram_url: "",
  twitter_url: "",
  whatsapp_url: "",
  footer_copyright: "",
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/api/settings");
      setSettings({ ...DEFAULTS, ...data });
    } catch {
      // keep defaults
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Apply colors to CSS variables
  useEffect(() => {
    if (!settings) return;
    const root = document.documentElement;
    if (settings.primary_color) root.style.setProperty("--primary", settings.primary_color);
    if (settings.secondary_color) root.style.setProperty("--secondary", settings.secondary_color);
    if (settings.accent_color) root.style.setProperty("--accent", settings.accent_color);
    if (settings.site_name) document.title = settings.site_name;
    if (settings.favicon_url) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = settings.favicon_url.startsWith("/")
        ? `${process.env.REACT_APP_BACKEND_URL}${settings.favicon_url}`
        : settings.favicon_url;
      document.head.appendChild(link);
    }
  }, [settings]);

  return (
    <SiteCtx.Provider value={{ settings, loaded, refresh: load }}>{children}</SiteCtx.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteCtx) || { settings: DEFAULTS, loaded: true };
